import * as React from 'react';
import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/teaserCard.svg?inline';
import { ButtonVariant, buttonVariants, IconName, iconNames } from '@/components/shared';
import { DamFileIdentifier } from '@/contexts/DamFileProvider';

export interface TeaserCardComponentProps {
	readonly image?: DamFileIdentifier | string;
	readonly altText?: string;
	readonly title: string;
	readonly text?: string;
	readonly icon?: IconName;
	readonly url?: string;
	readonly ctaLabel?: string;
	readonly hideCtaLabel?: boolean;
	readonly ctaButtonVariant?: ButtonVariant;
}

const register = <TProps extends TeaserCardComponentProps>(Component: React.FC<TProps>): void => {
	Builder.registerComponent(Component, {
		name: 'TeaserCard',
		image,
		inputs: [
			{
				name: 'image',
				type: 'Bizzkit DAM File',
			},
			{
				name: 'altText',
				type: 'string',
			},
			{
				name: 'title',
				type: 'string',
				required: true,
				defaultValue: 'Lorem ipsum',
			},
			{
				name: 'text',
				type: 'string',
				defaultValue: `Atque cupiditate eveniet inventore, ipsam
							mollitia nemo nostrum quia rem soluta temporibus.`,
			},
			{
				type: 'string',
				name: 'icon',
				enum: Array.from(iconNames),
			},
			{
				name: 'url',
				type: 'string',
			},
			{
				name: 'ctaLabel',
				type: 'string',
			},
			{
				name: 'hideCtaLabel',
				type: 'boolean',
				defaultValue: false,
			},
			{
				name: 'ctaButtonVariant',
				type: 'enum',
				enum: buttonVariants,
				defaultValue: 'primary',
			},
		],
	});
};

export default register;
